package modysy.tools

import org.scalajs.dom
import modysy.datastructures.Vector2

/** Provides all methods needed for a tool in the toolbox.
  * Different ways for the player to interact with the game world
  * can be implemented with this
  *
  * @see Toolbox
  */
trait Tool {

  /** Returns the non-negative amount of energy points needed to
    * use this tool once. This amount of points will be spent
    * using this tool once.
    *
    * @return energy cost to use this tool once
    */
  def cost: Int

  var uses: Int

  require(cost >= 0)

  /** World position of this tool. The tool may be rendered at this position
    * and the tool is used at this position.
    * A tool sometimes may not be anywhere in the game world and
    * tools without any position may exist.
    */
  protected var _position: Option[Vector2] = None

  /** Renders the icon of this tool onto the given rendering context.
    * The icon is drawn with its center at (0, 0) so the context
    * need to be translated correctly.
    *
    * @param ctx context to render the icon on
    */
  def renderIcon(ctx: dom.CanvasRenderingContext2D): Unit

  /** Renders the non-icon parts of this tool at the tools position set
    * by moveTo(...), moveBy(...) or even moveReset(...).
    * This may render nothing at all (e.g. is tool is not inside the game world).
    *
    * @param ctx context to render on
    */
  def render(ctx: dom.CanvasRenderingContext2D): Unit

  /** Uses this tool at the tools position set by moveTo(...),
    * moveBy(...) or even moveReset(...).
    *
    * Returns true if the tool was used successfully, otherwise false.
    *
    * @return Whether the interaction was successful.
    */
  def use(): Boolean

  /** Changes the world position of this tool to
    * the given world position relative to the upper left corner of the world.
    *
    * @param worldPos desired world position relative to the upper left corner of the world
    */
  def moveTo(worldPos: Vector2): Unit = {
    _position = Some(worldPos)
  }

  /** Changes the world position of this tools by the given world position delta.
    * The tool must be positioned somewhere in the game world before.
    *
    * @param worldDelta world position delta to be moved by
    */
  def moveBy(worldDelta: Vector2): Unit = {
    require(
      _position.isDefined,
      "moving tool relative, but not positioned absolute"
    )
    _position = Some(_position.get + worldDelta)
  }

  /** Resets this tools world position so it is not inside the game world any longer. */
  def moveReset(): Unit = {
    _position = None
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/tools/Tool.scala